import { useDisclosure } from '@chakra-ui/react';
import { api } from 'api/api';
import { AccountContext } from 'components/AccountContext';
import { userIsSubscriber } from 'components/Utils/theme';
import { useTelemedicina } from 'context/TelemedicinaContext';
import { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const ENDPOINT =
  process.env.REACT_APP_ENVIRONMENT === 'production'
    ? process.env.REACT_APP_BASE_URL_API_SERVER_PROD
    : process.env.REACT_APP_BASE_URL_API_SERVER_TEST;

const useViewDashboard = () => {
  const { setUser, user, toastInadimplente, webviewParams, toastSolicitacao } = useContext(AccountContext);
  const { setPaciente, setAgendamento, setMedicoSelecionado } = useTelemedicina();
  const assinante = userIsSubscriber(user);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const modalDependentes = useDisclosure();
  const disclosureAtendimento = useDisclosure();
  const modalClienteImportado = useDisclosure();
  const [notificacao, setNoficacao] = useState(false);
  const modalDeslogar = useDisclosure();
  const disclosureTelefone = useDisclosure();
  const modalCartaoV5 = useDisclosure();
  const navigate = useNavigate();
  const [valor, setValor] = useState({
    prontoAtendimento: {
      valor_clinico: 0,
      valor_pediatra: 0,
      valor_veterinario: 0,
      id_procedimento_clinico: 0,
      id_procedimento_pediatra: 0,
      id_procedimento_veterinario: 0,
    },
    especialista: {
      valor_psicologia: 0,
      valor_ortopedista: 0,
      valor_dermatologista: 0,
      valor_nutricionista: 0,
      id_procedimento_psicologia: 0,
      id_procedimento_ortopedista: 0,
      id_procedimento_dermatologista: 0,
      id_procedimento_nutricionista: 0,
    },
    prontoAtendimento_gratis: false,
  });

  async function fetchValoresTelemedicina() {
    try {
      setLoading(true);
      setError(null);
      const url = `${ENDPOINT}/pacientes/pesquisarValoresTelemedicina`;
      const postsData = await api(`${url}`, {
        method: 'POST',
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          username: user.username,
          assinante: assinante,
          plano_id: user.id_plano,
        }),
      });
      const response = await postsData.json();
      const cacheObj = {
        valores: response,
        userKey: `${user.username || ''}_${user.id_plano || ''}`,
      };
      sessionStorage.setItem('dashboardValoresTelemedicina', JSON.stringify(cacheObj));
      setUser((prevState) => ({
        ...prevState,
        pronto_gratis: response.prontoAtendimento_gratis,
      }));
      setValor(response);
    } catch (error) {
      setError('!');
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    fetchValoresTelemedicina();
  }, [user.username, user.id_plano]);

  useEffect(() => {
    setPaciente(null);
    setAgendamento(null);
    setMedicoSelecionado(null);
  }, []);

  let data_parcela = '';
  if (user?.qntdeParcelas?.countParcelas > 0) {
    data_parcela = user?.qntdeParcelas?.datasParcelas !== null ? new Date(user?.qntdeParcelas?.datasParcelas[0]) : null;
    if (data_parcela !== null) {
      const dia = user?.qntdeParcelas?.forma_pagamento === 13 ? 60 : 0;
      data_parcela.setDate(data_parcela?.getDate() + dia);
    }
  }
  const dataAtual = new Date();
  const clientePendente = user?.loggedIn && user?.qntdeParcelas?.countParcelas && user?.qntdeParcelas?.countParcelas > 0 && dataAtual >= data_parcela;

  /*
    Aqui são as coisas que existiam antes em OldMain, pra evitar de quebrar algm coisa
  */

  useEffect(() => {
    const simulateLoginEvent = () => {
      const contractId = user.id_contrato;
      const id_cliente_deovita = user.id_cliente_deovita;
      const cpf = user?.cpf ?? user?.username;
      const paciente_id_clinicas = user && user.client_deovita ? user?.client_deovita[0]?.paciente_id : 0;
      if (user.loggedIn) {
        const cookies = document.cookie;
        window?.ReactNativeWebView?.postMessage(
          JSON.stringify({
            sid: cookies?.sid,
            cpf,
            contractId: contractId,
            id_cliente_deovita: id_cliente_deovita,
            paciente_id_clinicas: paciente_id_clinicas,
          }),
        );
      }
    };
    simulateLoginEvent();
  }, [user, user.id_contrato]);

  useEffect(() => {
    if (webviewParams?.agenda_exames_id) {
      disclosureAtendimento.onOpen();
    }
    if (
      webviewParams?.link_confirmacao &&
      webviewParams?.link_confirmacao !== null &&
      webviewParams?.link_confirmacao !== undefined &&
      webviewParams?.link_confirmacao !== ''
    ) {
      window?.ReactNativeWebView?.postMessage(
        JSON.stringify({
          service: true,
          openInBrowser: true,
          url: `${webviewParams?.link_confirmacao}`,
        }),
      );
    }
  }, [webviewParams]);

  const updateCart = async () => {
    try {
      const res = await api(`${ENDPOINT}/cart/updateCart/${user.username}`, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json' },
      });
      const data = await res.json();
      handleCartUpdate(data);
    } catch (error) {
      console.error('Erro ao atualizar o carrinho:', error);
    }
  };

  const handleCartUpdate = (data) => {
    const ambulatorioOrcamentoIdsConsultas = data?.solicitacoes_consulta
      ? Object.values(data.solicitacoes_consulta).map((item) => item.notificacao_app)
      : [];
    const ambulatorioOrcamentoIdsSolicitacoes = data?.solicitacoes ? Object.values(data.solicitacoes).map((item) => item.notificacao_app) : [];
    const hasFalseNotification = ambulatorioOrcamentoIdsConsultas.includes(false) || ambulatorioOrcamentoIdsSolicitacoes.includes(false);

    setUser((prevState) => ({
      ...prevState,
      carrinho: { ...data.cart },
      solicitacoes: { ...data.solicitacoes },
      solicitacoes_consulta: { ...data.solicitacoes_consulta },
      qntde_solicitacoes: Object.values(data.solicitacoes || {}).length,
      qntde_solicitacoes_consulta: Object.values(data.solicitacoes_consulta || {}).length,
      build: prevState.build ? prevState.build : null,
    }));

    if (user.loggedIn && hasFalseNotification) {
      setNoficacao(true);
      toastSolicitacao();
    }
  };

  useEffect(() => {
    if (user.loggedIn) {
      if (
        !notificacao &&
        ((user?.solicitacoes_consulta && Object.keys(user.solicitacoes_consulta).length > 0) ||
          (user?.solicitacoes && Object.keys(user.solicitacoes).length > 0))
      ) {
        const ambulatorioOrcamentoIdsConsultas = user?.solicitacoes_consulta
          ? Object.values(user.solicitacoes_consulta).map((item) => item.notificacao_app)
          : [];
        const ambulatorioOrcamentoIdsSolicitacoes = user?.solicitacoes ? Object.values(user.solicitacoes).map((item) => item.notificacao_app) : [];

        const hasFalseNotification = ambulatorioOrcamentoIdsConsultas.includes(false) || ambulatorioOrcamentoIdsSolicitacoes.includes(false);

        if (hasFalseNotification) {
          setNoficacao(true);
          toastSolicitacao();
        }
      }
    }
  }, []);

  useEffect(() => {
    if (user.loggedIn) {
      setNoficacao(false);
      updateCart();
    }
  }, []);

  let usuarioAssinante = user.id_contrato && user.descricao_plano ? true : false;
  if (user.titular === false) usuarioAssinante = true;
  useEffect(() => {}, []);

  async function fetchDependentesDesatualizados() {
    const payload = {
      id_contrato: user.id_contrato,
    };
    const response = await api(`${ENDPOINT}/client/dependents-no-cpf`, {
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
      },
      method: 'POST',
      body: JSON.stringify(payload),
    });
    await response.json().then(async function (postsData) {
      if (postsData.data && postsData.data.length > 0) {
        modalDependentes.onOpen();
      }
    });
  }

  useEffect(() => {
    if (user.loggedIn && user.titular) {
      fetchDependentesDesatualizados();
    }
  }, []);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (user.loggedIn && !token) {
      modalDeslogar.onOpen();
      return;
    }
    if (user.id_plano !== 0 && user.id_plano !== null && user.id_plano !== undefined && !user.termo && user.titular === true) {
      console.log('Redirecionando para termo de adesão...');
      navigate('/termo-de-adesao');
      return;
    }

    //aplicando mudança nos modais
    //modal para cliente importado
    if (user.loggedIn && user?.clienteImportado?.clientImportado === true) {
      modalClienteImportado.onOpen();
      return; //nesse caso aqui eu quero que mostre só esse modal pra não poluir a tela
    }

    //se não, mantém do jeito que era
    if (user.loggedIn && !user?.aviso_psicologo) {
      ////modalPsicologo.onOpen();
    }

    if (user?.cards?.length === 0 && user?.id_forma_pagamento === 12 && usuarioAssinante) {
      modalCartaoV5.onOpen();
    }

    if (
      (user.loggedIn === true && (!user.phone1 || user.phone1 === undefined || user.phone1 === null || user.phone1 === '')) ||
      (user.loggedIn === true && (!user.data_aniv || user.data_aniv === undefined || user.data_aniv === null || user.data_aniv === '')) ||
      (user.loggedIn === true && (!user.cep || user.cep === undefined || user.cep === null || user.cep === ''))
    ) {
      disclosureTelefone.onOpen();
    }
  }, []);
  console.log('renderizou useViewDashboard', user.cep);
  return {
    user,
    assinante,
    loading,
    error,
    valor,
    toastInadimplente,
    clientePendente,
    disclosureAtendimento,
    modalDependentes,
    modalClienteImportado,
    modalDeslogar,
    disclosureTelefone,
    modalCartaoV5,
  };
};

export default useViewDashboard;
